import { createPersonalSidebarMotion, personalSidebarWidth } from "../services/personal-sidebar-motion.js";

/** 个人中心所有子页共享当前语言宽度，完全不依赖路由；初次进入英文页直接采用正确尺寸。 */
export default {
  computed: {
    personalSidebarLocale() { return this.$store.state.locale?.uiLocale || "zh-CN"; },
    personalSidebarStyle() {
      return { "--personal-sidebar-width": `${personalSidebarWidth(this.personalSidebarLocale)}px` };
    },
  },
  watch: {
    personalSidebarLocale() {
      const motion = this.sidebarLocaleMotion;
      const token = motion?.capture();
      this.$nextTick(() => motion?.commit(token));
    },
  },
  mounted() {
    this.sidebarLocaleMotion = createPersonalSidebarMotion({
      elements: () => ({
        sidebar: this.$refs.personalSidebar,
        surface: this.$refs.sidebarSurface,
        menu: this.$refs.menuRef?.$el,
        content: this.$refs.personalContent,
      }),
      reducedMotion: () => Boolean(window.matchMedia?.("(prefers-reduced-motion: reduce)").matches),
    });
  },
  beforeDestroy() { this.sidebarLocaleMotion?.dispose(); },
};
